import * as actions from "./settlement.actions";
import * as api from "./settlement.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./settlement.constants";
import * as hooks from "./settlement.hooks";
import * as promises from "./settlement.promises";
import { SettlementReducer } from "./settlement.reducer";
import { saga } from "./settlement.saga";
import * as selectors from "./settlement.selectors";
export * from "./settlement.types";
export var REDUCER_KEY_SETTLEMENTS = REDUCER_KEY;
export var settlementModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: SettlementReducer,
    saga: saga,
    selectors: selectors,
    utils: {},
};
